import { render, staticRenderFns } from "./baseconsultasconcelular.vue?vue&type=template&id=317b497c"
import script from "./baseconsultasconcelular.vue?vue&type=script&lang=js"
export * from "./baseconsultasconcelular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports